export const Title = ({value}) => {
    return (
        <div
            className="padding-section"
            style={{ marginBottom: "20px" }}
        >
            <div className="heading">{value}</div>
        </div>
    )
}
